import React from 'react';
import styled from 'styled-components';
import { Text } from '@volkswagen-onehub/components-core';

export const Super200Text = styled(Text as React.ComponentType<any>)`
	font-size: 112px;
	line-height: 100%;
	font-family: var(--font-family-head);
	font-weight: 100;
`;

export const Super200ResponsiveText = styled(Super200Text as React.ComponentType<any>)`
	@media (min-width: 960px) and (max-width: 1279px) {
		font-size: 90px;
	}
`;

export const Super200SymbolText = styled(Text as React.ComponentType<any>)`
	font-size: 56px;
	line-height: 120%;
	font-family: var(--font-family-head);
	font-weight: 100;
`;

export const Super200SymbolResponsiveText = styled(Super200SymbolText as React.ComponentType<any>)`
	@media (min-width: 960px) and (max-width: 1279px) {
		font-size: 45px;
	}
`;

export const Super100Text = styled(Text as React.ComponentType<any>)`
	font-size: 90px;
	line-height: 100%;
	font-family: var(--font-family-head);
	font-weight: 100;
`;

export const Super100ResponsiveText = styled(Super100Text as React.ComponentType<any>)`
	@media (max-width: 559px) {
		font-size: 60px;
	}

	@media (min-width: 560px) and (max-width: 959px) {
		font-size: 70px;
	}

	@media (min-width: 960px) and (max-width: 1279px) {
		font-size: 80px;
	}
`;

export const Super100SymbolText = styled(Text as React.ComponentType<any>)`
	font-size: 45px;
	line-height: 120%;
	font-family: var(--font-family-head);
	font-weight: 100;
`;

export const Super100SymbolResponsiveText = styled(Super100SymbolText as React.ComponentType<any>)`
	@media (max-width: 559px) {
		font-size: 30px;
	}

	@media (min-width: 560px) and (max-width: 959px) {
		font-size: 35px;
	}

	@media (min-width: 960px) and (max-width: 1279px) {
		font-size: 40px;
	}
`;

// dinero hucha renovadores popup
export const Super200ResponsiveTextRenovadoresPopup = styled(Super200Text as React.ComponentType<any>)`
	@media (min-width: 960px) and (max-width: 1279px) {
		font-size: 80px;
	}

	@media (min-width: 1280px) and (max-width: 1599px) {
		font-size: 90px;
	}
`;

export const Super200SymbolResponsiveTextRenovadoresPopup = styled(Super200SymbolText as React.ComponentType<any>)`
	@media (min-width: 960px) and (max-width: 1279px) {
		font-size: 40px;
	}

	@media (min-width: 1280px) and (max-width: 1599px) {
		font-size: 40px;
	}
`;
